import { useWeb3React } from "@web3-react/core";
import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import { ethers } from "ethers";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import verify_artists_icon from "../admin/imgs/userTick.svg";
import { User } from "../common/models/User";
import { useAuth } from "../hooks/useAuth";
import beta from "../imgs/beta.png";
import alpha from "../imgs/alpha.png";
import coinbase_logo from "../imgs/coinbase_logo.svg";
import compose_logo from "../imgs/compose_logo_half.svg";
import default_user_pic from "../imgs/default_user_pic.svg";
import dropdown_user_icon from "../imgs/dropdown_profile_icon.svg";
import dropdown_signout_icon from "../imgs/dropdown_signout_icon.svg";
import license_icon from "../imgs/license.svg";
import menu from "../imgs/menu_icon.png";
import metamask_fox from "../imgs/metamask_fox.svg";
import user_icon from "../imgs/user_icon.svg";
import SimpleButton from "./Buttons/SimpleButton";
import Dropdown, { DropdownIcon, DropdownText } from "./Dropdown/Dropdown";
import DropdownContent from "./Dropdown/DropdownContent";
import DropdownItem from "./Dropdown/DropdownItem";
import Row from "./Row/Row";
import Text from "./Text/Text";

export const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    color: #c1c1c1;
  }
`;

export const CreateNavLink = styled(NavLink)`
  @media screen and (max-width: 650px) {
    visibility: hiiden;
  }
`;

const NavMenu = styled("div")<{ showMenuItems: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow: visible;
  gap: 2rem;
  background: ${(props) => (props.showMenuItems ? "#000D30" : "transparent")};
  z-index: 1;
  width: 100%;
  margin-right: 2%;
  a {
    float: left;
    display: block;
    color: #f2f2f2;
    padding: 14px 16px;
    text-decoration: none;
    font-size: 20px;
    font-weight: 400;
    letter-spacing: 0.2px;
    z-index: 1;

    &:hover {
      font-weight: 1200;
    }
  }

  @media screen and (max-width: 500px) {
    flex-direction: column;
    overflow: visible;
    margin-top: 20%;
    gap: 0;
    a {
      display: ${(props) => (props.showMenuItems ? "block" : "none")};
      &:hover {
        color: black;
      }
    }
    p {
      display: ${(props) => (props.showMenuItems ? "block" : "none")};
      &:hover {
        color: black;
      }
    }

    img {
      display: ${(props) => (props.showMenuItems ? "block" : "none")};
      &:hover {
        color: black;
      }
    }
  }
`;
export const Bars = styled.div`
  background: url(${menu}) no-repeat;
  color: white;
  @media screen and (max-width: 650px) {
    display: block;
    position: absolute;
    top: 0;
    width: 35px;
    height: 35px;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const Nav = styled.nav<{showMenuItems?: boolean}>`
  position: absolute;
  top: 0;
  width: 100%;
  background: ${(props) => (props.showMenuItems ? "#000d30" : "transparent")};;
  height: 80px;
  display: flex;
  z-index: 1;
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

interface NavBarProps {
  themeToggler: Function;
  theme: string;
  hideNavLinks?: boolean;
}

const LogoLink = styled(NavLink)`
  margin-right: auto;
  z-index: 2;
`;

const MetaMaskConnectButton = styled("div")`
  position: relative;
  background: #000d30;
  border: 1px solid #ffffff90;
  border-radius: 15px;
`;

const CoinbaseConnectButton = styled(MetaMaskConnectButton)`
  margin-top: 5%;
`;
const ConnectWalletContainer = styled.div`
  padding: 20px 20px;
  font-size: 12px;
  background-color: ${(props) =>
    props.theme.themeType === "dark" ? "#000D30" : "#879AE4"};
  border-radius: 10px;
`;

const ConnectWalletImg = styled.img`
  width: 30px;
  height: 30px;
  position: absolute;
  left: 3%;
  top: 12%;
`;

const UserAccountImg = styled.img<{ connected?: boolean }>`
  padding: ${(props) => (props.connected ? "0" : "30%")};
  margin-left: ${(props) => (props.connected ? "30%" : "0%")};
  width: 30px;
  height: 30px;
  border: ${(props) => (props.connected ? "1px solid white" : "")};
  border-radius: 50%;
  object-fit: contain;
  @media screen and (max-width: 650px) {
    display: none;
  }
`;

const UserAccountRow = styled(Row)`
  display: block;
  @media screen and (max-width: 650px) {
    display: none;
  }
`;

const BetaImg = styled.img`
  position: absolute;
  left: 240px;
  top: 33%;
  width: 50px;
  height: 25px;

`;

const AlphaImg = styled.img`
  position: absolute;
  left: 240px;
  top: 33%;
  width: 70px;
  height: 25px;

`;

export const NavBar: React.FC<NavBarProps> = ({
  theme,
  themeToggler,
  hideNavLinks = false,
}) => {
  const [showMenuItems, setShowMenuItems] = useState(false);
  const navigate = useNavigate();
  const auth = useAuth();

  const [currentUser, setCurrentUser] = useState(auth.user);

  const usePolygonMainNet =
    process.env.REACT_APP_USE_POLYGON_MAINNET === "true";

  const CoinbaseWallet = new WalletLinkConnector({
    url: usePolygonMainNet
      ? process.env.REACT_APP_ALCHEMY_URL_POLYGON_MAINNET
      : process.env.REACT_APP_ALCHEMY_URL_MUMBAI,
    appName: "ComposeNFT",
    supportedChainIds: [137, 80001],
  });
  const Injected = new InjectedConnector({
    supportedChainIds: [137, 80001],
  });

  const { active, account, activate, deactivate } = useWeb3React();

  const activateInjectedProvider = async (
    providerName: "MetaMask" | "CoinBase"
  ) => {
    const { ethereum } = window;
    if (!ethereum?.providers) {
      return undefined;
    }

    let provider;
    switch (providerName) {
      case "CoinBase":
        provider = ethereum.providers.find(
          ({ isCoinbaseWallet }) => isCoinbaseWallet
        );
        break;
      case "MetaMask":
        provider = ethereum.providers.find(({ isMetaMask }) => isMetaMask);
        break;
    }

    if (provider) {

      ethereum.setSelectedProvider(provider);
      localStorage.setItem("connectedWalletProvider", providerName);
      provider.on("accountsChanged", (accounts) => {
        if (accounts.length === 0) {
          onSignOutClick();
        }
      });
    }
  };
  useEffect(() => {
    let provider = null;
    if (!window.ethereum?.providers) {
      // Only one provider avaiable, so switch networks using one
      provider = window.ethereum;
      if (window.ethereum) {
        provider.on("accountsChanged", (accounts) => {
          if (accounts.length === 0) {
            onSignOutClick();
          }
        });
      }
    } else {
      if (window.ethereum.selectedProvider) {
        provider = window.ethereum.selectedProvider;
        provider.on("accountsChanged", (accounts) => {
          if (accounts.length === 0) {
            onSignOutClick();
          }
        });
      }
    }
  });

  const onIconClick = () => {
    setShowMenuItems(!showMenuItems);
  };

  const onSignOutClick = async () => {
    setCurrentUser(null);
    navigate("/");
    deactivate();
    localStorage.removeItem("connectedWalletProvider");
    if (auth) {
      auth.signout(() => {
        auth.user = null;
      });
    }
  };

  const onProfileClick = () => {
    if (auth.user) {
      navigate("/user/" + auth.user.wallet_address);
    }
  };

  const networkMap = {
    POLYGON_MAINNET: {
      chainId: ethers.utils.hexValue(137), // '0x89'
      chainName: "Matic(Polygon) Mainnet",
      nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
      rpcUrls: ["https://polygon-rpc.com"],
      blockExplorerUrls: ["https://www.polygonscan.com/"],
    },
    MUMBAI_TESTNET: {
      chainId: ethers.utils.hexValue(80001), // '0x13881'
      chainName: "Matic(Polygon) Mumbai Testnet",
      nativeCurrency: { name: "tMATIC", symbol: "tMATIC", decimals: 18 },
      rpcUrls: ["https://rpc-mumbai.maticvigil.com"],
      blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
    },
  };

  const switchNetwork = async () => {
    const network = usePolygonMainNet
      ? networkMap.POLYGON_MAINNET
      : networkMap.MUMBAI_TESTNET;
    let provider = null;
    if (!window.ethereum?.providers) {
      // Only one provider avaiable, so switch networks using one
      provider = window.ethereum;
    } else {
      provider = window.ethereum.selectedProvider;
    }
    try {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: network.chainId }],
      });
    } catch (switchError) {
      if (switchError.code === 4902) {
        try {
          await provider.request({
            method: "wallet_addEthereumChain",
            params: [network],
          });
        } catch (error) {
        }
      }
    }
  };

  const onConnectWalletClick = async () => {
    activateInjectedProvider("MetaMask");
    switchNetwork();
    activate(Injected);
  };

  const onConnectCoinbaseClick = async () => {
    activateInjectedProvider("CoinBase");
    switchNetwork();
    activate(CoinbaseWallet);
  };

  useEffect(() => {
    if (active && !currentUser) {
      auth.signin(
        account,
        (user: User) => {
          setCurrentUser(user);
        },
        (errorMessage) => {
        }
      );
    }
  }, [active && !currentUser]);

  const onRevokeLicensesClick = () => {
    navigate("/revoke_licenses");
  };
  const onVerifyAritstsClick = () => {
    navigate("/verify_artists");
  };

  const isMobile = () => {
    return window.screen.width <= 650;
  };

  return (
    <Nav showMenuItems={showMenuItems}>
      <LogoLink to="/">
        <img
          style={{
            position: "absolute",
            left: "2rem",
            top: "1rem",
          }}
          src={compose_logo}
          alt="logo"
        />
      </LogoLink>
      {process.env.REACT_APP_IS_PRE_ALPHA === 'true' ?
      <AlphaImg src={alpha}/> : 
      <BetaImg src={beta} />
      }
      <NavMenu showMenuItems={showMenuItems}>
        {!hideNavLinks && <NavLink to="/explore">Explore</NavLink>}
        {!hideNavLinks && !isMobile() && (
          <NavLink to="/create_nft">Create</NavLink>
        )}
        {!hideNavLinks && <NavLink to="/howitworks">Resources</NavLink>}
        {!hideNavLinks && <NavLink to="/aboutus">About Us</NavLink>}

        {!hideNavLinks &&<Dropdown>
          <UserAccountRow onClick={onProfileClick}>
            <UserAccountImg
              src={
                currentUser === null
                  ? user_icon
                  : currentUser.profile_pic_s3_link === null
                  ? default_user_pic
                  : currentUser.profile_pic_s3_link
              }
              connected={currentUser !== null && currentUser.profile_pic_s3_link !== null}
            />
          </UserAccountRow>

          <DropdownContent
            width={currentUser === null ? "200%" : "100%"}
            minWidth={currentUser === null ? "300px" : "170px"}
            transform={
              currentUser === null
                ? "translate(-60%, 0%)"
                : "translate(-40%,0%)"
            }
          >
            {currentUser && (
              <DropdownItem onClick={onProfileClick}>
                <DropdownIcon src={dropdown_user_icon} />
                <DropdownText>Profile</DropdownText>
              </DropdownItem>
            )}
            {auth.user && auth.isAdmin && (
              <DropdownItem onClick={onRevokeLicensesClick}>
                <DropdownIcon src={license_icon} />
                <DropdownText>Revoke Licenses</DropdownText>
              </DropdownItem>
            )}

            {auth.user && auth.isAdmin && (
              <DropdownItem onClick={onVerifyAritstsClick}>
                <DropdownIcon src={verify_artists_icon} />
                <DropdownText>Verify Aritsts</DropdownText>
              </DropdownItem>
            )}

            {/* TODO: We will add this back when light mode is ready
            {currentUser && (
              <DropdownItem>
                <DropdownIcon src={dropdown_settings_icon} />
                <DropdownText>Setting</DropdownText>
              </DropdownItem>
            )}
            <DropdownItem>
              <DropdownIcon src={dropdown_sun_icon} />
              {theme === "dark" ? (
                <DropdownText>Light Mode</DropdownText>
              ) : (
                <DropdownText>Dark Mode</DropdownText>
              )}
              <Switch theme={theme} onChange={themeToggler} />
            </DropdownItem> */}
            {currentUser && (
              <DropdownItem onClick={onSignOutClick}>
                <DropdownIcon src={dropdown_signout_icon} />
                <DropdownText>Disconnect</DropdownText>
              </DropdownItem>
            )}
            {!currentUser && (
              <ConnectWalletContainer>
                <Text size={"16px"}>Connect Wallet</Text>
                <MetaMaskConnectButton>
                  <ConnectWalletImg src={metamask_fox} />
                  <Text style={{ marginLeft: "15%" }} size={"14px"}>
                    Metamask
                  </Text>
                  <SimpleButton
                    style={{ marginLeft: "15%", padding: "0.5rem 1rem" }}
                    onClick={onConnectWalletClick}
                  >
                    Connect
                  </SimpleButton>
                </MetaMaskConnectButton>
                <CoinbaseConnectButton>
                  <ConnectWalletImg src={coinbase_logo} />
                  <Text style={{ marginLeft: "15%" }} size={"14px"}>
                    Coinbase
                  </Text>
                  <SimpleButton
                    style={{ marginLeft: "18%", padding: "0.5rem 1rem" }}
                    onClick={onConnectCoinbaseClick}
                  >
                    Connect
                  </SimpleButton>
                </CoinbaseConnectButton>
              </ConnectWalletContainer>
            )}
          </DropdownContent>
        </Dropdown>}
        <Bars onClick={onIconClick} />
      </NavMenu>
    </Nav>
  );
};
